import React from 'react'
import { ReferenciaContenido } from '../../../interfaces/ReferenciaContenido'
import GridCardsSection from '../../organisms/grid-cards-section/girdCardsSection'
import CardColumns from '../../molecules/card-colums/cardColumns'
import ContentLeftRight from '../../molecules/content-left-right/contentLeftRight'
import Gallery from '../../organisms/gallery/gallery'
import GalleryExtended from '../../organisms/gallery-extended/galleryExtended'
import VideoLink from '../../molecules/video-link/videoLink'
import SubsectionContainer from '../../molecules/subsection-container/subsectionContainer'
import DiscoverAppSection from '../../molecules/discover-app/discoverAppSection'
import DownloadsList from '../../molecules/downloads-list/downloadsList'
import OfficesList from '../../molecules/offices-list/officesList'
import GalleryCards from '../../organisms/gallery-cards/galleryCards'
import RichtextDescription from '../../atoms/richtext-description/richtextDescription'
import VideoService from '../../organisms/video-service/videoService'
import FrequentlyAskedQuestions from '../../molecules/frequent-questions/frequent-questions'
import ArticleContentDescription from '../../molecules/article-content-description/articleContentDescription'
import SpotifyListen from '../../atoms/spotify-listen/spotifyListen'
import Readtime from '../../atoms/readtime/readTime'
import PriceInformation from '../../organisms/price-information/priceInformation'
import History from '../../organisms/history/history'
import SectionContainer from '../../molecules/section-container/sectionContainer'
import Axis from '../../organisms/axis/axis'
import Carousel from '../../organisms/carousel/carousel'
import TabsSection from '../../molecules/tabs-section/tabsSection'
import ContentRotator from '../../molecules/content-rotator/contentRotator'
import CoursesSection from '../../organisms/courses-section/coursesSection'
import ResultsCardList from '../../organisms/results-card-list/resultsCardList'

interface LibraryInterface {
   content: ReferenciaContenido;
   categoryName:string;
}

const LibraryComponents = (props:LibraryInterface) => {

   const refContent = props.content;
   const categoryName = props.categoryName;

   switch ( props.content.tipoComponente ) {
      case 'AgregadosCategoria': 
         return <GridCardsSection { ...refContent } nombreCategoria={ categoryName } /> 
      case 'InformacionInstitucional':
         return <CardColumns { ...refContent } nombreCategoria={ categoryName } /> 
      case 'Wellness':
         return <ContentLeftRight {...refContent} nombreCategoria={ categoryName } />
      case 'Galeria':
         return <Gallery { ...refContent } nombreCategoria={ categoryName }  /> 
      case 'GaleriaExtendida':
         return <GalleryExtended { ...refContent } nombreCategoria={ categoryName }  />
      case 'Destacados':
         return <VideoLink { ...refContent } nombreCategoria={ categoryName }   />
      case 'DestacadoParaTi':
         return <GalleryCards { ...refContent } nombreCategoria={ categoryName } />
      case 'Beneficios':
         return <SubsectionContainer { ...refContent } nombreCategoria={ categoryName }   />
      case 'Publicidad':
         return <DiscoverAppSection { ...refContent } nombreCategoria={ categoryName }   />
      case 'DocumentosInteres':
         return <DownloadsList { ...refContent } nombreCategoria={ categoryName }  />
      case 'NuestrasSedes':
         return <OfficesList { ...refContent } nombreCategoria={ categoryName }  />
      case 'ContenidoEnriquecido' : 
         return <RichtextDescription { ...refContent } nombreCategoria={ categoryName } />
      case 'VideoService' : 
         return <VideoService { ...refContent } nombreCategoria={ categoryName }  />
      case 'PreguntasFrecuentes' :
         return <FrequentlyAskedQuestions { ...refContent } nombreCategoria={ categoryName } />
      case 'ContenidoEnriquecidoArticulo' : 
         return <ArticleContentDescription { ...refContent } nombreCategoria={ categoryName }  />
      case 'Spotify' :
         return <SpotifyListen  { ...refContent } nombreCategoria={ categoryName }  />
      case 'TiempoLectura' : 
         return <Readtime   { ...refContent } nombreCategoria={ categoryName }  />
      case 'Tarifas' :
         return <PriceInformation  { ...refContent } nombreCategoria={ categoryName }  />
      case 'Historia' :
         return <History { ...refContent } nombreCategoria={ categoryName }   />
      case 'SectionContainer' : 
         return <SectionContainer { ...refContent } nombreCategoria={ categoryName } />
      case 'Ejes' : 
         return <Axis { ...refContent } nombreCategoria={ categoryName }  />
      case 'GaleriaPrincipal' :
         return <Carousel { ...refContent } nombreCategoria={ categoryName }  />
      case 'SeccionTabs' : 
         return <TabsSection { ...refContent } nombreCategoria={ categoryName }  />
      case 'RotadorPrincipal':
         return <ContentRotator { ...refContent } nombreCategoria={ categoryName } />
      case 'SeccionCursos' : 
         return <CoursesSection { ...refContent } nombreCategoria={ categoryName } />
      case 'Cartas' : 
         return <ResultsCardList { ...refContent } nombreCategoria={ categoryName }  />
   }

   return (<></>)
}

export default LibraryComponents;
